module.exports = __webpack_public_path__ + "static/media/maha.1e9ac396.jpg";